
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.783 15.674H1.815A.818.818 0 011 14.859V1.815C1 1.367 1.367 1 1.815 1H12.08c.212 0 .424.09.57.236l2.789 2.788a.822.822 0 01.236.571v3.742","stroke":"#221B38","stroke-width":"1.3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.307 11.272l-2.022 3.497-.057.905.758-.497L16 11.679l-.693-.407z","stroke":"#221B38","stroke-width":"1.3","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M10.783 12.413H4.26M4.26 8.337h8.153M4.26 4.26h4.077M11.598 1v4.076h4.076v-.48a.822.822 0 00-.237-.572L12.65 1.236A.822.822 0 0012.08 1h-.481z","stroke":"#221B38","stroke-width":"1.3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    